"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.getDeviceId = void 0;
var _loadScript = _interopRequireDefault(require("../loadScript"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let _loadPromise;
const init = () => {
  if (!_loadPromise) {
    _loadPromise = new Promise((res, rej) => {
      (0, _loadScript.default)('https://www.mercadopago.com/v2/security.js', () => {
        res();
      });
    });
  }
  return _loadPromise;
};
exports.init = init;
const getDeviceId = async () => {
  return init().then(() => global['MP_DEVICE_SESSION_ID']);
};
exports.getDeviceId = getDeviceId;